export function PhaseLabel({ index, children }: { index: string; children: React.ReactNode }) {
  return <p className="phase-label"><span>{index}</span> // {children}</p>;
}
